var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 445,
    viewBox: "0 0 446 445",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212.145 0.267123L222.688 445L233.958 444.733L223.414 -3.66182e-05L212.145 0.267123Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1435 73.0239L380.093 380.026L387.872 371.868L65.9227 64.8659L58.1435 73.0239Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.86429 233.298L445.597 222.755L445.33 211.486L0.597131 222.029L0.86429 233.298Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6213 387.3L380.624 65.35L372.466 57.5708L65.4633 379.521L73.6213 387.3Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6213 387.3L380.624 65.35L372.466 57.5708L65.4633 379.521L73.6213 387.3Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.736 315.156L429.702 140.057L425.265 129.694L16.2992 304.793L20.736 315.156Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.652 430.979L311.009 18.0095L300.545 13.8195L135.188 426.789L145.652 430.979Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M315.753 424.707L140.654 15.7415L130.291 20.1783L305.39 429.144L315.753 424.707Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M431.576 299.791L18.6069 134.434L14.4169 144.898L427.386 310.255L431.576 299.791Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M431.576 299.791L18.6069 134.434L14.4169 144.898L427.386 310.255L431.576 299.791Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M168.802 6.6275L266.316 440.684L277.315 438.213L179.8 4.15656L168.802 6.6275Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0929 108.228L407.96 346.187L413.99 336.663L38.1226 98.7036L32.0929 108.228Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22492 276.642L441.281 179.127L438.81 168.128L4.75398 265.643L7.22492 276.642Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.825 413.35L346.784 37.4825L337.26 31.4529L99.301 407.32L108.825 413.35Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.825 413.35L346.784 37.4825L337.26 31.4529L99.301 407.32L108.825 413.35Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9119 352.993L409.615 101.154L403.234 91.8625L36.5305 343.701L42.9119 352.993Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.919 442.131L269.151 4.73865L258.068 2.68028L176.836 440.073L187.919 442.131Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M353.591 402.531L101.752 35.828L92.46 42.2094L344.299 408.913L353.591 402.531Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M442.729 257.524L5.33594 176.292L3.27757 187.375L440.67 268.608L442.729 257.524Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M442.729 257.524L5.33594 176.292L3.27757 187.375L440.67 268.608L442.729 257.524Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.821b67212f22db81887ad2e1ea8cde29.svg";
export { ForwardRef as ReactComponent };